import React from 'react';
import { Chip, Stack } from '@mui/material';
import { USER_IMPORT_REVIEW_STATUSES } from './UserImportReviewStatusChip';

const hasErrors = (row) => Object.keys(row.errors).length > 0;
const hasWarnings = (row) => Object.keys(row.warnings).length > 0;

// Which rows each chip counts. A row with an error and a warning counts as both, so a
// warning shows before its row's error is fixed; the counts can add up to more than the rows.
const COUNTS = {
	ready: (row) => !hasErrors(row) && !hasWarnings(row),
	warning: hasWarnings,
	error: hasErrors,
};

/**
 * How many reviewed rows are ready (no problems), have warnings and have errors, as chips.
 * Counted by what each row has, not its status: a row's status is only its worst problem.
 */
export const UserImportReviewSummary = ({ rows }) => (
	<Stack direction='row' spacing={1}>
		{Object.entries(USER_IMPORT_REVIEW_STATUSES).map(([status, { label, color }]) => (
			<Chip
				key={status}
				size='small'
				variant='outlined'
				color={color}
				label={`${rows.filter(COUNTS[status]).length} ${label.toLowerCase()}`}
			/>
		))}
	</Stack>
);
